import {
    AbstractPmsApiService
} from "./abstract.service";

import {
    Schedule
} from '../models';

export class SchedulePmsApiService extends AbstractPmsApiService {

    get urlPattern() {

        return '/property/:propertyId/schedule(/:id)(/:option)';
    }

    newModel(attributes, ...params) {

        return new Schedule(attributes);
    }

    get(params = {}, property = {}) {

        const url = this.url({ propertyId: property ? property.id : 0 });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    create(schedule = {}, property) {

        const url = this.url({ propertyId: property.id });

        return this.http.post(url, schedule, {
            headers: this.authHeaders,
        })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    update(schedule = {}) {

        const url = this.url({ propertyId: schedule.property.id, id: schedule.id});

        return this.http.put(url, schedule, {
            headers: this.authHeaders,
        }).then(this.getModeler())
            .catch(this.getErrorHandler());;
    }

    delete(model) {

        const url = this.url({
            propertyId: model.property.id,
            id: model.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    show(schedule, property){
        const url = this.url({
            propertyId: property,
            id: schedule
        });

       return this.http.get(url, {
            headers: this.authHeaders
        })
        .then(this.getModeler())
        .catch(this.getErrorHandler());
     }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/schedule.serivce.js